<app-dialog-base>
  <span dialog-title>Void the version in effect from {{ data.effectiveFrom }}?</span>
  <ng-container dialog-content>
    <p data-testid="void-rule-version-explanation">
      Reports stop using this version: periods from {{ data.effectiveFrom }} go back to the version before it, or to no
      rule if there is none. It stays in the change history, marked voided with your reason. This can't be undone.
    </p>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Reason</mat-label>
      <textarea matInput
                rows="3"
                [formControl]="reasonControl"
                [maxlength]="reasonMaxLength"
                data-testid="void-rule-version-reason-input"></textarea>
      <mat-hint align="end">{{ reasonControl.value.length }} / {{ reasonMaxLength }}</mat-hint>
      @if (reasonControl.touched && !canVoid) {
        <mat-error>Enter a reason for voiding this version.</mat-error>
      }
    </mat-form-field>
  </ng-container>
  <ng-container actions>
    <button mat-button class="mat-warn" [disabled]="!canVoid" data-testid="void-rule-version-confirm-button" (click)="voidVersion()">
      Void version
    </button>
  </ng-container>
</app-dialog-base>
